module.exports = __webpack_public_path__ + "static/ga-0a16859dfe055111d53e98b949e64bdb.png";